import React from "react";
import {MenuItem} from "@material-tailwind/react";
import {useTranslation} from "react-i18next";
import {ManageAccounts, Assignment, AutoStories} from "@mui/icons-material";
import {useNavigate} from "react-router";
import {useSessionStore} from "../../services/storage/session/SessionStorage";
import {RolEnum} from "../../services/enum/PermissionConst";

interface Props {
    visible: boolean;
    toggleIsNavOpen?: any;
}

const navListItemsAdmin = [
    {
        label: "departments",
        icon: Assignment,
        path: "/departments"
    },
    {
        label: "admin-user",
        icon: ManageAccounts,
        path: "/admin-user"
    },
    {
        label: "processes",
        icon: AutoStories,
        path: "/processes"
    },
];

const navListItems = [
    {
        label: "processes",
        icon: AutoStories,
        path: "/processes"
    },
];

export function MenusHeader({visible, toggleIsNavOpen}: Props) {
    const {t} = useTranslation("global") as { t: (key: string) => string }
    const user = useSessionStore(data => data.user)

    const history = useNavigate();

    function RenderMenus(menus: any[]) {
        return (
            <>
                {menus.map(({label, icon, path}) => (
                    <MenuItem
                        key={label}
                        placeholder={'menu'}
                        className="flex items-center gap-2 w-auto text-[13px]"
                        onClick={() => {
                            if (path) {
                                history(`${path}`)
                            }
                            if (toggleIsNavOpen) toggleIsNavOpen()
                        }}
                    >
                        {`${t(label)} `}
                        {React.createElement(icon, {className: "max-w-4"})}
                    </MenuItem>
                ))}
            </>
        )
    }

    return (
        <div className={`${!visible ? 'hidden sm:block' : ''} bg-headerMenus min-h-[54px] sm:max-h-[54px] p-[6px]`}>
            <ul className="flex flex-col sm:flex-row gap-2 justify-center items-center">
                {user?.rol === RolEnum.ADMIN ? RenderMenus(navListItemsAdmin) : RenderMenus(navListItems)}
            </ul>
        </div>
    )
}
